import type { DocHistoryResponse } from '../../openapi/types';
import type { ServerErrors } from '../../types';
import * as con from '../constants';
import { QUERY_STATE } from '../../constants';
import { AnyAction } from 'redux';

export const defaultValues = {
  url: '',
  name: '',
  description: '',
  type: '',
  state: con.DOC_STATE.INPROGRESS,
  documentation_type: con.DOCUMENTATION_TYPES.DSPS,
  geometry_plan_number: '',
  has_planimetry: false,
  has_utilities: false,
  data_origin: con.DATA_ORIGIN_TYPES.GEODETIC_SURVEYING,
  cadasters: [] as { url: string }[],
  street: '',
  owner_name: '',
  owner_street: '',
  owner_city: '',
  owner_postal_code: '',
  owner_ico: '',
  owner_birth_number: '',

  processor_name: '',
  processor_street: '',
  processor_city: '',
  processor_postal_code: '',
  processor_ico: '',
  processor_birth_number: '',

  note: '',
  creator: '',
  author: {} as any,
  geodesist: {} as any,
  receiver: '',
  rejection_reason: '' as con.REJECTION_REASON,
  rejection_note: '',
  utilities_type: {} as { url: string },
  history: [] as DocHistoryResponse[],
};
export type DocEditValues = typeof defaultValues;

const docState = {
  data: defaultValues,
  errors: null as ServerErrors | null,
  submitQueryState: QUERY_STATE.EMPTY,
  loadQueryState: QUERY_STATE.EMPTY,
};
type DocState = typeof docState;

export const docedit = (state = docState, action: AnyAction): DocState => {
  switch (action.type) {
    case con.DOCEDIT_LOAD_SUCCESS:
      return {
        ...state,
        ...{
          data: action.data,
          loadQueryState: QUERY_STATE.SUCCESS,
        },
      };
    case con.DOCEDIT_LOAD_FAILURE:
      return {
        ...state,
        ...{
          loadQueryState: QUERY_STATE.FAIL,
        },
      };
    case con.DOCEDIT_LOAD_WAITING:
      return {
        ...state,
        ...{
          loadQueryState: QUERY_STATE.WAITING,
        },
      };

    case con.DOCEDIT_CLEAR:
      return {
        ...state,
        ...{
          data: defaultValues,
          queryState: QUERY_STATE.EMPTY,
        },
      };
    case con.DOCEDIT_SUBMIT_FAILURE:
      return {
        ...state,
        ...{
          submitQueryState: QUERY_STATE.FAIL,
          errors: action.payload,
        },
      };
    case con.DOCEDIT_SUBMIT_SUCCESS:
      return {
        ...state,
        ...{
          submitQueryState: QUERY_STATE.SUCCESS,
          errors: null,
        },
      };
    case con.DOCEDIT_SUBMIT_WAITING:
      return {
        ...state,
        ...{
          submitQueryState: QUERY_STATE.WAITING,
          errors: null,
        },
      };
    default:
      return state;
  }
};
